export const agreementStatuses = {
  NOT_ACCEPTED: "Nie zaakceptowana",
  ACCEPTED: "Zaakceptowana",
  NOT_CONFIRMED: "Nie zatwierdzona",
  APPROVED: "Zatwierdzona",
  EXPIRED: "Wygasła",
};
